import { Select, Tabs, Toggle } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const StyledPlansBlockHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('400')};
    margin-bottom: ${getPurpurSpacing('300')};

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('600')};
        margin-bottom: ${getPurpurSpacing('400')};
    `};
`;

export const FiltersRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('300')} ${getPurpurSpacing('150')};

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('200')};
    `};
`;
export const ToggleTelia1 = styled(Toggle)`
    flex-grow: 1;
    flex-basis: 100%;
    ${purpurMedia('lg')`
        flex-basis: auto;
    `}
`;

export const StyledSelect = styled(Select)`
    max-width: 26.56rem;
    flex-grow: 1;
    &:only-child {
        margin-left: auto;
    }
`;

export const TabsContainer = styled.div`
    display: block;
`;

export const StyledTabs = styled(Tabs)`
    display: block;
    width: fit-content;
    max-width: calc(100vw - ${getPurpurSpacing('600')});
    margin: 0 auto;

    [class*='_purpur-tabs__content-container'] {
        display: none;
    }

    ${purpurMedia('md')`
        max-width: calc(100vw - ${getPurpurSpacing('800')});
    `}
`;
